<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { init } from './utils/notification-factory'
export default {
  mounted() {
    init(this.$toasted)
  }
}
</script>
<style lang="scss">
@import '@/style/app.scss';
</style>
